import { SettingsInitState } from './reducers';

const getSettingsState = ({ pages: { settingsPage } }) => settingsPage as SettingsInitState;

export const getClientContractModalMode = state => getSettingsState(state).clientContractModalMode;
export const getEditedClientContract = state => getSettingsState(state).editedClientContract;
export const getEditedClientID = state => getSettingsState(state).editedClientID;
export const getTriggerReFetchClients = state => getSettingsState(state).triggerReFetchClients;
